

import React, { useState } from 'react'

import useTranslation from '@/Hooks/UseTranslation'
import { useAuth } from '@/Hooks/UseAuth'
import { useTeams } from '@/Hooks/UseTeam'

import UserAvatar from '@/Components/UserAvatar/UserAvatar'

import Spinner from '@/Components/SvgImages/Spinner/Spinner'

import './InternalProfilesTabItem.scss'
import { assignInternalProfile } from '@/Services/web/InternalProfileService'

interface Props {
  profile: any
}

const InternalProfilesTabItem = (props: Props) => {

  const { profile } = props

  const { t } = useTranslation()

  const { teamSelected, addInternalProfile } = useTeams()

  const [ isAdding, setIsAdding ] = useState(false)
  const [ isAdded, setIsAdded ] = useState(profile.isInTeam)

  const handleAddUser = async (user: any) => {

    if (isAdding || isAdded) return

    setIsAdding(true)

    await assignInternalProfile({ team_id: teamSelected._id, internalProfile_id: profile._id })

    addInternalProfile(user)

    setIsAdding(false)

    setIsAdded(true)
  }

  return (
    <div className="internal-profiles-tab-item"
      onClick={() => handleAddUser(profile)}
    >
      <UserAvatar user={props.profile} />
      <div className="user-texts">
        <div className="user-name">
          {props.profile.name} {props.profile.surname}
        </div>
        <div className="user-email">
          {props.profile.email}
        </div>
      </div>
      <div>
        {isAdded && t('TEAMMEMBER_SELECTOR:UserListUserAlreadyInTeam')}
        {isAdding && (
          <Spinner height={24} width={24} />
        )}
      </div>
    </div>
  )
}

export default InternalProfilesTabItem

